import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled, { css } from 'styled-components';
import { g as getRem, a as getPadding } from './styled-utils-3f8463ca.js';

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: column;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: ", ";\n  border-radius: ", ";\n  ", ";\n  ", ";\n  ", ";\n  transition: 0.2s border-color;\n\n  &:focus {\n    border-color: #1a202c;\n    outline: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var baseStyles = css(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borders.thin;
}, function (_ref3) {
  var theme = _ref3.theme;
  return getRem(theme.radii.md);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.base;
}, function (_ref5) {
  var theme = _ref5.theme;
  return getPadding('py-xs', theme);
}, function (_ref6) {
  var theme = _ref6.theme;
  return getPadding('px-sm', theme);
});
var StyledLabel = styled.label(_templateObject2());
var TextInput = styled.input(_templateObject3(), baseStyles);

var Input = function Input(_ref) {
  var id = _ref.id,
      type = _ref.type,
      placeholder = _ref.placeholder,
      className = _ref.className,
      children = _ref.children;
  return React.createElement(StyledLabel, {
    htmlFor: id,
    className: className && "".concat(className, " ").concat(className, "-label")
  }, children, React.createElement(TextInput, {
    type: type,
    name: id,
    id: id,
    placeholder: placeholder,
    className: className && "".concat(className, " ").concat(className, "-input")
  }));
};

Input.defaultProps = {
  className: null,
  placeholder: null,
  type: 'text'
};
Input.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Input",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "placeholder": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The placeholder text for the Input"
    },
    "type": {
      "defaultValue": {
        "value": "'text'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'text'",
          "computed": false
        }, {
          "value": "'email'",
          "computed": false
        }, {
          "value": "'tel'",
          "computed": false
        }, {
          "value": "'number'",
          "computed": false
        }, {
          "value": "'date'",
          "computed": false
        }, {
          "value": "'search'",
          "computed": false
        }]
      },
      "required": false,
      "description": "The type of input field"
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": true,
      "description": "The label text for the input"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "The unique identifier for the Input"
    }
  }
};
export default Input;
export { Input };